import React, { useState, useEffect, useRef } from "react";
import ImportAdtInfoStatusProgressComponent from "./importAdtInfoStatusProgress.component";
import { useDispatch, useSelector } from "react-redux";
import {
  getImportProgress,
  updateImportProgress,
} from "modules/serial-number/redux";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  IMPORT_ADT_STATUS_FAIL,
  IMPORT_ADT_STATUS_SUCCESS,
} from "modules/serial-number/constants";

function ImportAdtInfoStatusProgressContainer({
  importUuid,
  initialProgress = 0,
  initialStatus,
}) {
  const lang = useSelector((state) => state.constant.languages);
  const [status, setStatus] = useState(initialStatus);
  const [progress, setProgress] = useState(initialProgress);
  const dispatch = useDispatch();

  const intervalRef = useRef(null);

  useEffect(() => {
    if (
      initialStatus !== IMPORT_ADT_STATUS_SUCCESS &&
      initialStatus !== IMPORT_ADT_STATUS_FAIL
    ) {
      intervalRef.current = setInterval(() => {
        getData();
      }, 5000);
      dispatch(updateImportProgress(true));
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, importUuid]);

  const getData = () => {
    dispatch(getImportProgress({ import_uuid: importUuid }))
      .then(unwrapResult)
      .then((data) => {
        setStatus(data.status);
        setProgress(data.progress);

        if (
          data.status === IMPORT_ADT_STATUS_SUCCESS ||
          data.status === IMPORT_ADT_STATUS_FAIL
        ) {
          clearInterval(intervalRef.current);
          dispatch(updateImportProgress(false));
        }
      })
      .catch(() => {
        setStatus("failed");
        setProgress(0);
        clearInterval(intervalRef.current);
      });
  };

  return (
    <ImportAdtInfoStatusProgressComponent
      progress={progress}
      status={status}
      lang={lang}
    />
  );
}

export default ImportAdtInfoStatusProgressContainer;
